import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';
import ScrollContainer from 'react-indiana-drag-scroll';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';
import { palette } from '@styles/theme';

import { GROUP_LIST_HEADER } from '@constants/tableheader';

interface Props {
  isButtonShow?: boolean;
}

/** 홈 > 조합 목록 스켈레톤 */
const GroupListSkeleton = ({ isButtonShow = false }: Props) => {
  /** 테이블 용 데이터 가공 */
  const tableData = useMemo(
    () =>
      Array.from({ length: 10 })?.map((_: any, i: number) => ({
        id: i,
        no: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        displayId: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        name: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        type: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        totalPayment: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        contractAmount: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        portfolioCount: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        portfolioAmount: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        period: (
          <div css={items}>
            <Skeleton variant="text" width={160} />
          </div>
        ),
      })),
    []
  );

  return (
    <>
      <div css={titleStyle}>
        <Skeleton variant="text" width={70} />
      </div>
      <div css={counts}>
        <div>
          <Skeleton variant="text" width={50} />
        </div>
        {isButtonShow && (
          <div className="buttonWrap">
            <Skeleton
              variant="rectangular"
              width={118}
              height={36}
              sx={{ borderRadius: '5px' }}
            />
            <Skeleton
              variant="rectangular"
              width={88}
              height={36}
              sx={{ borderRadius: '5px' }}
            />
          </div>
        )}
      </div>
      <ScrollContainer css={tableWrap} hideScrollbars={false}>
        <Table header={GROUP_LIST_HEADER} data={tableData} />
      </ScrollContainer>
    </>
  );
};

export default GroupListSkeleton;

const counts = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 10px;
  strong {
    font-weight: 700;
  }
  .buttonWrap {
    display: flex;
    gap: 10px;
  }
`;

const tableWrap = css`
  border-radius: 5px 5px 0 0;
  overflow-x: auto;
  padding: 1px;
  &::-webkit-scrollbar {
    width: 4px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette.gray4};
    height: 30%;
  }
  &::-webkit-scrollbar-track {
    background: ${palette.gray3};
  }

  table {
    width: calc(1920px - 250px - 82px);
  }
`;

const items = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;
